import { Instance, types } from "mobx-state-tree";
import { IAgent } from "../agent/Agent";
import { Guest, IGuest } from "../base/Guest";
import { agentStoreGetter, guestStoreGetter } from "../utils";

export const UsersStore = types
  .model("UsersStore", {
    users: types.map(Guest)
  })
  .views(guestStoreGetter)
  .views(agentStoreGetter)
  .views((self) => ({
    getById(id: string): IGuest | IAgent {
      const guest = self.guestStore.guests.get(id);
      if (guest) {
        return guest;
      }

      return self.agentStore.getOrLoad(id);
    }
  }));

export interface IUsersStore extends Instance<typeof UsersStore> {}
